import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { selectIsLoggedIn } from 'features/auth/authSelectors';

import { AppModules } from 'constants/enums';
import { AUTH } from 'constants/path';

import PermissionWrapper from './PermissionWrapper';

interface ProtectedRouteProps {
  children: ReactNode;
  module: AppModules | null;
}

const ProtectedRoute = ({
  children,
  module
}: ProtectedRouteProps): ReactNode => {
  const isAuthenticated = useSelector(selectIsLoggedIn);
  // const { notification } = App.useApp();

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     notification.info({
  //       message: 'You must be logged in to access this page. Please login to continue.',
  //       placement: 'topRight',
  //       duration: DEFAULT_NOTIFICATION_SHOW_DURATION_SEC,
  //     });
  //   }
  // }, [isAuthenticated, notification]);

  if (!isAuthenticated) {
    return <Navigate to={AUTH} replace />;
  }

  return <PermissionWrapper module={module}>{children}</PermissionWrapper>;
};

export default ProtectedRoute;
